import { getFilter } from 'api/filter'
import { URL_STRINGIFY_OPTIONS } from 'application/configuration/constants'
import { combine, createEffect, createEvent, createStore, restore } from 'effector'
import { createGate } from 'effector-react'
import { FilterValue, FilterValues } from 'features/filter/types'
import { appendUrl } from 'lib/append-url'
import { objectHasProperty } from 'lib/typescript-helpers'

import { FilterDeclaration, FilterField, FilterSection } from '.'

/**
 * Устанавливает одно значение фильтра
 */
export const replaceValues = createEvent<FilterValues>()

export const setValues = createEvent<FilterValues>()

export const mergeValues = createEvent<FilterValues>()

export const removeValues = createEvent<FilterValues>()

export const resetValues = createEvent()

export const hasCitySelection = createGate<{ enabled: boolean }>()

/**
 * Значения фильтра, плоский обект массивов вида {filterKey: [value1, value2], ...}
 */
export const $filterValues = createStore<FilterValues | null>(null)

export const $internalFilterValues = restore(setValues, null)

export const $disabledFilterValues = createStore<FilterValues | null>(null)

export const $defaultFilterValues = createGate<FilterValues>()

export const $permanentFilterValues = createGate<FilterValues>({ defaultState: {} })

/**
 *
 */
export const fetchDeclarationFx = createEffect(getFilter)

export const $fetchFailed = createStore(false).on(fetchDeclarationFx.fail, () => true)

export const $fetching = fetchDeclarationFx.pending

export const $declaration = createStore<null | FilterDeclaration>(null)

export const $isFilterReady = combine($declaration, $fetching, $filterValues, (d, f, fi) => !!d && !f && !!fi)

export const getFilterValuesFromUrlFx = createEffect()

/**
 * Эффект сохранения значений фильтра в URL страницы
 */
export const propagateToURLFx = createEffect((data: FilterValues) => {
  const url = appendUrl({
    url: window.location.href,
    parseOptions: URL_STRINGIFY_OPTIONS,
    stringifyOptions: URL_STRINGIFY_OPTIONS,
    data
  })
  window.history.replaceState({}, '', url)
})
